import axios from "axios";
import { getAuthorizationToken } from "../config/user";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function getDefaultStageTimeColor() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-stage-time-color`,
    headers: getAuthorizationToken(),
  });
}
function getRawStatusTimeColor(page, limit, searchKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/raw-status-time-color?page=${page}&limit=${limit}&searchKey=${searchKey}`,
    headers: getAuthorizationToken(),
  });
}

function updateStatusTimeColor(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/manage-status-time-color`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getCaseStageReport(
  startDate,
  endDate,
  hospitalId,
  page,
  status,
  searchKey,
  reportOfRpa,
) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()
  ) {
    end.setHours(23, 59, 59, 999);
  }

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-stage-report?startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}&page=${page}&status=${status}&searchKey=${encodeURIComponent(
      searchKey || "",
    )}&reportOfRpa=${reportOfRpa}`,
    headers: getAuthorizationToken(),
  });
}
function getCaseStageReport2(
  startDate,
  endDate,
  hospitalId,
  page,
  status,
  searchKey,
  dataType,
  assignedUser,
  caseType, // <-- new param
) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-stage-report2?startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}&page=${page}&status=${status}&searchKey=${encodeURIComponent(
      searchKey || "",
    )}&dataType=${dataType}&assignedTo=${assignedUser}${
      caseType ? `&caseType=${caseType}` : "" // <-- append only if present
    }`,
    headers: getAuthorizationToken(),
  });
}

function getProcessedStageCount(startDate, endDate, hospitalId) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // if (
  //   start.getFullYear() === end.getFullYear() &&
  //   start.getMonth() === end.getMonth() &&
  //   start.getDate() === end.getDate()
  // ) {
  //   end.setHours(23, 59, 59, 999);
  // }

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/processed-stage-count-report?startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}`,
    headers: getAuthorizationToken(),
  });
}
function getProcessedStageCountNew(
  startDate,
  endDate,
  hospitalId,
  dataType,
  caseType,
) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // if (
  //   start.getFullYear() === end.getFullYear() &&
  //   start.getMonth() === end.getMonth() &&
  //   start.getDate() === end.getDate()
  // ) {
  //   end.setHours(23, 59, 59, 999);
  // }

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/processed-stage-count-report2?startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}&dataType=${dataType}&caseType=${caseType}`,
    headers: getAuthorizationToken(),
  });
}
function getCcDiffStageCaseCount(hospitalId, from, to, searchKey, status) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-diff-case-stage-count?searchKey=${encodeURIComponent(
      searchKey || "",
    )}&hospitalId=${hospitalId}&startDate=${new Date(
      from,
    ).toISOString()}&endDate=${new Date(to).toISOString()}&status=${status}`,
    headers: getAuthorizationToken(),
  });
}

function getCaseStageUserList(commandCenterStage, isOnlyActiveUser, role) {
  const params = new URLSearchParams({
    commandCenterStage,
  });

  if (isOnlyActiveUser !== undefined) {
    params.append("isOnlyActiveUser", isOnlyActiveUser);
  }
  if (role) {
    params.append("role", role);
  }

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-stage-user-list?${params.toString()}`,
    headers: getAuthorizationToken(),
  });
}
function assignCaseStage(stageId, userId, reAssign = false) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/assign-case-stage/${stageId}?assignedTo=${userId}&reAssign=${reAssign}`,
    headers: getAuthorizationToken(),
  });
}
function getUsers() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/all-userid-username`,
    headers: getAuthorizationToken(),
  });
}
function getHsaReportforHsa(page = 1, limit = 10, hospitalId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hsa-doc-time-report?page=${page}&limit=${limit}&hospitalId=${hospitalId}`,
    headers: getAuthorizationToken(),
  });
}
function getHsaReport(
  page = 1,
  limit = 10,
  hospitalId,
  dataType,
  from,
  to,
  patientKey,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hsa-doc-time-report2?page=${page}&limit=${limit}&patientKey=${patientKey}&hospitalId=${hospitalId}&dataType=${dataType}&from=${new Date(
      from,
    ).toISOString()}&to=${new Date(to).toISOString()}`,
    headers: getAuthorizationToken(),
  });
}
function getDiffStageCaseCount(hospitalId, from, to, patientKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hsa-diff-stage-case-count?patientKey=${patientKey}&hospitalId=${hospitalId}&from=${new Date(
      from,
    ).toISOString()}&to=${new Date(to).toISOString()}`,
    headers: getAuthorizationToken(),
  });
}
function getRpaCaseWiseReport(
  startDate,
  endDate,
  hospitalId,
  page,
  caseStatus,
  searchKey,
  sortByTime,
  filterByDateType,
  processedBy,
  orderBy,
) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()
  ) {
    end.setHours(23, 59, 59, 999);
  }

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-process-time-report?caseStatus=${caseStatus}&startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}&page=${page}&patientSearchKey=${searchKey}&sortBy=${sortByTime}&filterBy=${filterByDateType}&processedBy=${processedBy}&sortOrder=${orderBy}`,
    headers: getAuthorizationToken(),
  });
}
function getHsaMonthlyReport(startDate, endDate, hospitalId, filterStage) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-monthly-case-report?startDate=${new Date(
      startDate,
    ).toISOString()}&endDate=${new Date(
      endDate,
    ).toISOString()}&hospitalId=${hospitalId}&commandCenterStage=${filterStage}`,
    headers: getAuthorizationToken(),
  });
}
function getHsaMonthlyClaimReport(
  startDate,
  endDate,
  hospitalId,
  claimType = "",
) {
  const claimTypeParam = claimType ? `&claimType=${claimType}` : "";

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-monthly-claim-report?startDate=${new Date(
      startDate,
    ).toISOString()}&endDate=${new Date(
      endDate,
    ).toISOString()}&hospitalId=${hospitalId}${claimTypeParam}`,
    headers: getAuthorizationToken(),
  });
}
function getHsaMonthlyClaimReportCount(hospitalId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-monthly-claim-report-count?hospitalId=${hospitalId}`,
    headers: getAuthorizationToken(),
  });
}

/** CC doctor case count statistics (doctorsList, total, totalPages, per-doctor *Report) */
function getCcDoctorCaseCountReport({ limit = 10, page = 1, doctorId } = {}) {
  const params = { limit, page };
  const did = doctorId != null ? String(doctorId).trim() : "";
  if (did) params.doctorId = did;
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-doctor-case-count-report`,
    params,
    headers: getAuthorizationToken(),
  });
}

function getDutCcUserCaseCountReport({ limit = 10, page = 1, ccUserId } = {}) {
  const params = { limit, page };

  const uid = ccUserId != null ? String(ccUserId).trim() : "";
  if (uid) params.ccUserId = uid;

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dut-cc-user-case-count-report`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** CC doctor processed stage list (Report grid). Pass query params your API expects, e.g. page, limit. */
function getCcDoctorProcessedStageList(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-doctor-processed-stage-list`,
    params,
    headers: getAuthorizationToken(),
  });
}

function getDutCcUserProcessedStageList(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dut-cc-user-processed-stage-list`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** Per-bucket counts for header filters (daycare, conservative, surgical, admission, enhancement, dischargeclaim, …). */
function getCcDoctorProcessedStageCount(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-doctor-processed-stage-count`,
    params,
    headers: getAuthorizationToken(),
  });
}

function getDutCcUserProcessedStageCount(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dut-cc-user-processed-stage-count`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** CC user stage time action. Pass query params when the backend contract is finalized. */
function getCcUserStageTimeAction(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-user-stage-time-action`,
    params,
    headers: getAuthorizationToken(),
  });
}

function getDutCcUserStageTimeAction(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dut-cc-user-stage-time-action`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** CC case stage process report (formattedReport by stage index). Query matches GET …/cc-case-stage-process-report */
function getCcCaseStageProcessReport({
  doctorId,
  startDate = "",
  endDate = "",
} = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/cc-case-stage-process-report`,
    params: { doctorId, startDate, endDate },
    headers: getAuthorizationToken(),
  });
}

function getDutCcCaseStageProcessReport({
  ccUserId,
  startDate = "",
  endDate = "",
} = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dut-cc-case-stage-process-report`,
    params: { ccUserId, startDate, endDate },
    headers: getAuthorizationToken(),
  });
}

/** CC stage time rows. Optional `userId`, `stageStatusId`, `page`, `limit` query params. Pass `{ userId, stageStatusId, page, limit }` or a single `userId` for backward compatibility. */
function getCcStageTime(userIdOrOpts) {
  let userId;
  let stageStatusId;
  let page;
  let limit;
  if (
    userIdOrOpts != null &&
    typeof userIdOrOpts === "object" &&
    !Array.isArray(userIdOrOpts)
  ) {
    ({ userId, stageStatusId, page, limit } = userIdOrOpts);
  } else {
    userId = userIdOrOpts;
  }
  const params = {};
  if (userId != null && String(userId).trim() !== "") {
    params.userId = String(userId);
  }
  if (stageStatusId != null && String(stageStatusId).trim() !== "") {
    const n = Number(stageStatusId);
    if (Number.isFinite(n)) params.stageStatusId = String(n);
  }
  if (page != null && String(page).trim() !== "") {
    const p = Math.max(1, Math.floor(Number(page)));
    if (Number.isFinite(p)) params.page = String(p);
  }
  if (limit != null && String(limit).trim() !== "") {
    const l = Math.max(1, Math.floor(Number(limit)));
    if (Number.isFinite(l)) params.limit = String(l);
  }
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-cc-stage-time`,
    params,
    headers: getAuthorizationToken(),
  });
}

function getCcStageTimeBeta(userIdOrOpts) {
  let userId;
  let stageStatusId;
  let page;
  let limit;
  if (
    userIdOrOpts != null &&
    typeof userIdOrOpts === "object" &&
    !Array.isArray(userIdOrOpts)
  ) {
    ({ userId, stageStatusId, page, limit } = userIdOrOpts);
  } else {
    userId = userIdOrOpts;
  }
  const params = {};
  if (userId != null && String(userId).trim() !== "") {
    params.userId = String(userId);
  }
  if (stageStatusId != null && String(stageStatusId).trim() !== "") {
    const n = Number(stageStatusId);
    if (Number.isFinite(n)) params.stageStatusId = String(n);
  }
  if (page != null && String(page).trim() !== "") {
    const p = Math.max(1, Math.floor(Number(page)));
    if (Number.isFinite(p)) params.page = String(p);
  }
  if (limit != null && String(limit).trim() !== "") {
    const l = Math.max(1, Math.floor(Number(limit)));
    if (Number.isFinite(l)) params.limit = String(l);
  }
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-cc-stage-time-beta`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** Master list: `id` → stageStatusId, `commandCenterStageStatus` → label. */
function getDefaultCaseStages(params = {}) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-case-stages`,
    params,
    headers: getAuthorizationToken(),
  });
}

/** Create/update doctor stage time slots (array body). */
function manageCcUserStageTime(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/manage-cc-user-stage-time`,
    data,
    headers: getAuthorizationToken(),
  });
}

export const ReportServices = {
  getCaseStageReport,
  getDefaultStageTimeColor,
  updateStatusTimeColor,
  getCaseStageUserList,
  assignCaseStage,
  getUsers,
  getHsaReport,
  getRpaCaseWiseReport,
  getHsaReportforHsa,
  getCaseStageReport2,
  getDiffStageCaseCount,
  getCcDiffStageCaseCount,
  getProcessedStageCount,
  getRawStatusTimeColor,
  getProcessedStageCount,
  getProcessedStageCountNew,
  getHsaMonthlyReport,
  getHsaMonthlyClaimReport,
  getHsaMonthlyClaimReportCount,
  getCcDoctorCaseCountReport,
  getCcDoctorProcessedStageList,
  getCcDoctorProcessedStageCount,
  getCcUserStageTimeAction,
  getCcCaseStageProcessReport,
  getCcStageTime,
  getDefaultCaseStages,
  manageCcUserStageTime,
  getDutCcUserProcessedStageList,
  getDutCcUserProcessedStageCount,
  getDutCcUserStageTimeAction,
  getDutCcUserCaseCountReport,
  getDutCcCaseStageProcessReport,
  getCcStageTimeBeta,
};
